const publicUrl = window.myLocalizedData ? window.myLocalizedData.PUBLIC_URL : "";

export const AboutNatasha = () => {
    return (
        <section className="about-natasha" id="about">
            <div className="about-container">
                <div className="image-wrapper">
                    <img
                        src={`${publicUrl}/natasha-headshot.jpeg`} // Update the path!
                        alt="Natasha Sharpe, LPC, M.Ed."
                        className="headshot"
                    />
                </div>
                <div className="text-content">
                    <h2>Meet Natasha Sharpe, LPC, M.Ed.</h2>
                    <p>
                        With nearly two decades of experience, Natasha Sharpe is a
                        Licensed Professional Counselor and psychotherapist who is
                        passionate about guiding individuals on their mental wellness
                        journey. Natasha has worked with people of all ages across school,
                        home, private practice, and telehealth settings. She currently
                        provides therapy for adults in an outpatient, private practice
                        environment.
                    </p>
                    <p>
                        Natasha holds a Bachelor of Arts in Psychology from the University
                        of Tennessee, Knoxville and a Master of Education in Counseling and
                        Development from George Mason University. She also maintains a
                        license in Professional School Counseling and enjoys helping parents
                        navigate mental health and academic challenges their children may
                        face.
                    </p>

                    <h3>Natasha Says...</h3>
                    <p>
                        Hi! I'm Natasha (she/her). I'm a southern girl raised in the suburbs
                        who loves Arnold Palmers, fried foods, stand-up comedy, live music,
                        funky-colored eyeglasses—and bees!
                    </p>
                    <p>
                        I have a heart for first-time therapy clients and proudly advocate
                        for the BIPOC community. As a woman of color, I'm committed to
                        breaking the stigma around mental health that has kept too many from
                        accessing care. I'm also trained to support members of the Christian
                        community and provide faith-informed counseling when desired.
                    </p>

                    <a href="/contact" className="cta-button">Schedule Your Consultation</a>
                </div>
            </div>
        </section>
    );
};